import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { apiErr } from "../SuperHeader";
import { useAdminFetch, TabState } from "../useAdminFetch";

export default function LeadFinderAccess({ cid, path = "lead-finder", title = "Business Finder access", unit = "searches" }) {
  const { data, error, loading, reload } = useAdminFetch(`/admin/companies/${cid}/${path}`);
  const [f, setF] = useState({ enabled: true, unlimited: true, limit: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (data) setF({ enabled: data.access.company_enabled, unlimited: data.access.monthly_limit == null, limit: data.access.monthly_limit ?? "" });
  }, [data]);
  const save = async () => {
    const n = Number(f.limit);
    if (!f.unlimited && (f.limit === "" || !Number.isInteger(n) || n < 0)) return toast.error("Enter a whole number of searches, or choose unlimited");
    setBusy(true);
    try {
      await api.patch(`/admin/companies/${cid}/${path}`, { enabled: f.enabled, ...(f.unlimited ? { unlimited: true } : { monthly_limit: n }) });
      toast.success(`${title} saved`); reload();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <Card className="p-5 border-slate-200 max-w-xl space-y-3" data-testid={`${path}-access`}>
      <h3 className="font-semibold">{title}</h3>
      <TabState loading={loading && !data} error={error} testid="lf-access">
        {data && <>
          <p className="text-xs text-slate-500" data-testid={`${path}-used`}>Used this month: {data.access.used_this_month} {unit}{data.access.monthly_limit != null ? ` of ${data.access.monthly_limit}` : " (unlimited)"}</p>
          <label className="flex items-center justify-between p-3 rounded-lg border border-slate-200 text-sm">
            <span>Allow this company to use it</span>
            <Switch checked={f.enabled} onCheckedChange={(v) => setF({ ...f, enabled: v })} data-testid={`${path}-enabled-switch`} />
          </label>
          <label className="flex items-center justify-between p-3 rounded-lg border border-slate-200 text-sm">
            <span>Unlimited {unit}</span>
            <Switch checked={f.unlimited} onCheckedChange={(v) => setF({ ...f, unlimited: v })} data-testid={`${path}-unlimited-switch`} />
          </label>
          {!f.unlimited && <Input type="number" min={0} value={f.limit} onChange={(e) => setF({ ...f, limit: e.target.value })} placeholder={`${unit[0].toUpperCase()}${unit.slice(1)} per month`} data-testid={`${path}-limit-input`} />}
          <Button onClick={save} disabled={busy} className="bg-indigo-600 hover:bg-indigo-700" data-testid={`${path}-access-save`}>{busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}Save access</Button>
        </>}
      </TabState>
    </Card>
  );
}
